<script>
    import { formatStack } from './libs';
    export let item = { 'item': 'Stone', 'qty': 64, 'price': 1 }, items;
</script>

<div class="flex flex-row items-center justify-start p-2 min-h-[3.75rem] truncate transition-colors duration-200 ease-in-out bg-gray-200 rounded-md cursor-pointer shrink-0 hover:bg-gray-300">
    <i class="icon-minecraft mr-2 flex-none {items.filter(a => a.label == item.item).length > 0 ? items.filter(a => a.label == item.item)[0].css : 'icon-minecraft-air'}"></i>
    <div class="flex flex-col items-start justify-center flex-1">
        <p title={item.item}>{item.item}</p>
        <span class="text-sm">{formatStack(item.qty)} per {formatStack(item.price)} Dia</span>
    </div>
</div>